// extracted by mini-css-extract-plugin
export var activeDot = "_4j-c";
export var buttonContainer = "_4j-9";
export var channelButton = "_4j-a";
export var clickable = "_4j-d";
export var content = "_4j-0";
export var contentFull = "_4j-2";
export var contentThird = "_4j-1";
export var contentWrapper = "_4j-7";
export var description = "_4j-5";
export var heightShort = "_4j-f";
export var image = "_4j-3";
export var imageContainer = "_4j-4";
export var selectButton = "_4j-e";
export var spinnerContainer = "_4j-b";
export var titleContent = "_4j-8";
export var titleWrapper = "_4j-6";